import React from "react";
import "./WhyChoose.css";

const WhyChoose = () => {
  return (
    <section className="why-choose-wrapper">
      <h2 className="why-choose-title">Why Choose Us</h2>
      <div className="why-choose-box">
        <div className="why-choose-card">
          <h3>Premium Quality</h3>
          <p>Sourced and purified to the highest standards.</p>
        </div>
        <div className="why-choose-card">
          <h3>Custom Labels</h3>
          <p>Tailored branding to match your business or event theme.</p>
        </div>
        <div className="why-choose-card">
          <h3>Bulk Ordering Options</h3>
          <p>Flexible quantities to suit your needs.</p>
        </div>
        <div className="why-choose-card">
          <h3>Sustainable Solutions</h3>
          <p>Eco-friendly packaging choices available.</p>
        </div>
      </div>
    </section>
  );
};

export default WhyChoose;
